// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2794) return "static/chunks/23918f63-4ebb47556dedeac4.js";
	if (chunkId === 5480) return "static/chunks/5480-39d5b15cfbad7cc9.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"136":"609b3b71c05d857c","6391":"e1aa07e8db4847dc","9184":"698e5decd5a4b0c5","9656":"5f5e4ae8fd21a2ba","9853":"d655ecf7cf2169ae"}[chunkId] + ".js";
};